import { call, put, takeLatest, select } from 'redux-saga/effects'
import Alert from 'react-s-alert';
import _ from 'lodash'
import { push } from 'react-router-redux'
import { selectors as company_selectors } from '../sagas/account';
import { defineTypes } from '../helpers'
import CompanyEndpoint from '../persistence/CompanyEndpoint'
import { reduxFetch } from '../http/reduxFetch'
import { selectors as account_selectors } from '../sagas/sign_up/account_information';
import config from '../config'
import moment from 'moment'

const stripeInfoTypes = { ...defineTypes('STRIPE_INFO')  }

export const initialState = {
  loading: false,
  loaded: false,
  created: false,
  fees: 'pass_on',
  'collectSalesTax': false,
  'collectTips': false,
}

export const actions = {
  getStripeInfo () {
    return { type: stripeInfoTypes.REQUEST }
  },
  createStripeInfo (create) {
    return { type: 'CREATE_STRIPE_INFO', create: create || false }
  },
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case stripeInfoTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case stripeInfoTypes.DESTROY:
      return { ...state, loading: false }
    case stripeInfoTypes.FAILURE:
      return { ...state, loading: false, error: action.error}
    case stripeInfoTypes.SUCCESS:
      return { ...state, loading: false, loaded: true }
    default:
      return state
  }
}
export const selectors = {
  stripe_settings: (state) => {
    return state.form && state.form.bank_account_form && state.form.bank_account_form.values
  },
  loaded: ({ stripe_settings }) => {
    return stripe_settings && stripe_settings.loaded
  },
}

function submitStripe (form){
  let stripe = window.Stripe(config.STRIPE_API_KEY)
  return stripe.createToken('bank_account', {
    country: 'US',
    currency: 'usd',
    routing_number: form['routing_number'],
    account_number: form['account_number'],
    account_holder_type: 'company',
  })
}

function snakeCaseRequiredValues (form) {
  let values = ['routingNumber', 'accountNumber']
  var snake_case_form = {}
  values.forEach( value => {
    snake_case_form[_.snakeCase(value)] = form[value]
  })
  return snake_case_form
}

export function * createStripeInfoSagas(action) {
  try {
    const stripe_settings = yield select(selectors.stripe_settings)
    const birthdate = yield select(account_selectors.birthdate)
    const stripe_values = yield call(snakeCaseRequiredValues, stripe_settings)
    // Do not send stripe_settings to the server!
    const stripe_response = yield call(submitStripe, stripe_values)
    // Send the token from the stripe_response to the server
    let company_params = {
      ...stripe_settings,
      birthdate: birthdate,
      external_account: stripe_response && stripe_response['token'] && stripe_response['token']['id'],
      tos_acceptance: moment(),
    }
    const company_update = yield call(reduxFetch, CompanyEndpoint.update_stripe(company_params))
    if ( company_update['data'] ) {
      yield put({ type: stripeInfoTypes.SUCCESS })
      yield call(Alert.success, '<div>Bank Account Info Updated!</div>')
      yield call(console.log, action)
      if ( action.create ) yield put(push('/products'))
    } else {
      yield put({ type: stripeInfoTypes.FAILURE, errors: company_update.errors })
    }
  } catch (error) {
    yield call(() => console.log(error))
    yield put({ type: stripeInfoTypes.FAILURE, error })
  }
}
export function * stripeInfoSaga () {
  try {
    yield call(reduxFetch, CompanyEndpoint.index())
    yield put({ type: stripeInfoTypes.SUCCESS })
  } catch (error) {
    yield put({ type: stripeInfoTypes.FAILURE, error })
  }
}

export function * rootSaga () {
  yield takeLatest('CREATE_STRIPE_INFO', createStripeInfoSagas)
  yield takeLatest(stripeInfoTypes.REQUEST, stripeInfoSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/stripe_settings.js